/* eslint-disable import/prefer-default-export */
export const APPEND_WORKSHOP_UNSCHEDULED_VISITS = 'APPEND_WORKSHOP_UNSCHEDULED_VISITS';
export const GET_WORKSHOP_UNSCHEDULED_VISITS = 'GET_WORKSHOP_UNSCHEDULED_VISITS';
